import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { HeaderButtonBaseProps } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";
import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";

type CartButtonContextValue = {
    headerButtonProps: HeaderButtonBaseProps;
    redirect?: string;
    cart?: CartModel | null;
    isUpdatingCart?: Record<string, boolean>;
    activeId: string;
    onRemoveFromCart?: (id: string, quantity: number, free: boolean) => void;
};

type CartButtonContextProviderProps = {
    headerButtonProps: HeaderButtonBaseProps;
    redirect?: string;
    cart?: CartModel | null;
    isUpdatingCart?: Record<string, boolean>;
    activeId: string;
    onRemoveFromCart?: (id: string, quantity: number, free: boolean) => void;
    children: ReactNode;
};

export const CartButtonContext = createContext<
    CartButtonContextValue | undefined
>(undefined);

export const CartButtonContextProvider = ({
    headerButtonProps,
    redirect,
    cart,
    isUpdatingCart,
    activeId,
    onRemoveFromCart,
    children
}: CartButtonContextProviderProps) => {
    return (
        <CartButtonContext
            value={{
                headerButtonProps: headerButtonProps,
                redirect: redirect,
                cart: cart,
                isUpdatingCart: isUpdatingCart,
                activeId: activeId,
                onRemoveFromCart: onRemoveFromCart
            }}
        >
            {children}
        </CartButtonContext>
    );
};

export const useCartButtonContext = () => {
    const context = use<CartButtonContextValue | undefined>(CartButtonContext);

    if (!isDefined(context)) {
        throw new Error(`${CartButtonContext.displayName} is undefined.`);
    }

    return context;
};
